export const BULK_UPLOAD_START   = "BULK_UPLOAD_START";
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS";
export const BULK_UPLOAD_FAIL    = "BULK_UPLOAD_FAIL";

export const BULK_SUMMARY_GET     = "BULK_SUMMARY_GET";
export const BULK_SUMMARY_SUCCESS = "BULK_SUMMARY_SUCCESS";
export const BULK_SUMMARY_FAIL    = "BULK_SUMMARY_FAIL";

export const BULK_TASK_STATUS_UPDATE = "BULK_TASK_STATUS_UPDATE";

export const BULK_TASKS_LIST_GET     = "BULK_TASKS_LIST_GET";
export const BULK_TASKS_LIST_SUCCESS = "BULK_TASKS_LIST_SUCCESS";
export const BULK_TASKS_LIST_FAIL    = "BULK_TASKS_LIST_FAIL";

export const BULK_RESET = "BULK_RESET";
